import { filterFacilityTypesKey } from "../config/constants";
import { IngredientFilterKeys } from "../config/enums/IngredientType.enum";
import { ClientRequestFilterKeys } from "../screens/mapping_interaction/enums/MappingReplies.enum";

export const TOKEN = "IdToken";
const COMPANY_TOKEN = "CompanyToken";
const TENANT_ID = "tenantId";
const USER_TENANT_ID = "userTenantId";
const REFRESH_TOKEN = "refreshToken";
const TOKEN_EXPIRED_IN = "tokenExpiredIn";
const USER_ROLES = "userRoles";
const NEW_DRAWING_ITEM = "newDrawingItem";
const USER_PERMISSIONS = "userPermissions";
const USER_ID = "userId";
const OIDC_TOKEN = "oidcToken";
const OIDC_USER = "oidcUser";
const COMPANY_ID = "companyId";
const COMPANY_NAME = "companyName";
const COMPANY_TENANT_ID = "companyTenantId";
const CALCULATE_STATUS = "calculateStatus";
const CURRENT_FILTER_PRODUCT_IDS = "currentFilterProductIds";
const CURRENT_FILTER_SALES_UNIT_IDS = "currentFilterSalesUnitIds";
const USER_LAST_ACTION = "userLastAction";
const SUPPLIER_ORDER_BY = "supplierOrderBy";
const PRODUCT_ORDER_BY = "productOrderBy";

const parseStoredJsonValue = <T>(raw: string | null, fallback: T): T => {
  if (!raw) return fallback;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return raw as T;
  }
};

// Original token
export const getTokenInLocal = () =>
  localStorage.getItem(COMPANY_TOKEN)
    ? localStorage.getItem(COMPANY_TOKEN)
    : localStorage.getItem(TOKEN);

// Original token
export const getRefreshTokenInLocal = () => {
  return localStorage.getItem(REFRESH_TOKEN);
};

export const getNewDaringItemStatus = () => {
  return localStorage.getItem(NEW_DRAWING_ITEM);
};

export const removeNewDrawingItemStatus = () => {
  return localStorage.removeItem(NEW_DRAWING_ITEM);
};

export const saveNewDrawingItem = (status: string) =>
  localStorage.setItem(NEW_DRAWING_ITEM, status);

// Original token company
export const getTokenInForCompanyLocal = () => localStorage.getItem(TOKEN);

export const getUserPermissionsInLocal = () => {
  const userRoles = localStorage.getItem(USER_PERMISSIONS) || "[]";
  return JSON.parse(userRoles);
};

export const saveUserPermissionsInLocal = (permissions: [any]) =>
  localStorage.setItem(USER_ROLES, JSON.stringify(permissions));

export const getUserRolesInLocal = () => {
  const userRoles = localStorage.getItem(USER_ROLES) || "[]";
  return JSON.parse(userRoles);
};
export const saveTokenInLocal = (userToken: string) => localStorage.setItem(TOKEN, userToken);

export const saveUserRoleInLocal = (userToken: string) =>
  localStorage.setItem(USER_ROLES, userToken);

export const getUserIdInLocal = () => {
  return localStorage.getItem(USER_ID);
};
export const saveUserIdInLocal = (userId: string) => localStorage.setItem(USER_ID, userId);

export const saveRefreshTokenInLocal = (refreshToken: string) =>
  localStorage.setItem(REFRESH_TOKEN, refreshToken);

export const saveTokenExpiration = (expiresIn: number) => {
  localStorage.setItem(TOKEN_EXPIRED_IN, expiresIn.toString());
};
export const getTokenExpiration = () => {
  return localStorage.getItem(TOKEN_EXPIRED_IN);
};

export const saveCompanyTokenInLocal = (companyToken: string) =>
  localStorage.setItem(COMPANY_TOKEN, companyToken);

export const saveTenantId = (tenantId: string) => localStorage.setItem(TENANT_ID, tenantId);

export const saveUserTenantId = (tenantId: string) =>
  localStorage.setItem(USER_TENANT_ID, tenantId);

export const getUserTenantId = () => localStorage.getItem(USER_TENANT_ID);

//check token is available
export const checkAuthTokenAvailable = () => {
  return localStorage.getItem(TOKEN);
};

export const saveOidcToken = (oidcToken: string) => {
  localStorage.setItem(OIDC_TOKEN, oidcToken);
};

export const getOidcToken = () => {
  return localStorage.getItem(OIDC_TOKEN);
};

export const setOidcUser = (user: any) => {
  localStorage.setItem(OIDC_USER, JSON.stringify(user));
};

export const getOidcUser = () => {
  const user = localStorage.getItem(OIDC_USER);
  return user ? JSON.parse(user) : null;
};

//remove all tokens
export const removeTokens = async () => {
  localStorage.removeItem(TOKEN);
  localStorage.removeItem(COMPANY_TOKEN);
  localStorage.removeItem("companyName");
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem(TENANT_ID);
  localStorage.removeItem(TOKEN_EXPIRED_IN);
  localStorage.removeItem(USER_TENANT_ID);
  localStorage.removeItem(USER_ROLES);
  localStorage.removeItem(NEW_DRAWING_ITEM);
  localStorage.removeItem(USER_ID);
  localStorage.removeItem(OIDC_TOKEN);
  localStorage.removeItem(OIDC_USER);
  localStorage.removeItem(COMPANY_ID);
  localStorage.removeItem(COMPANY_TENANT_ID);
  localStorage.removeItem(CALCULATE_STATUS);
  localStorage.removeItem(CURRENT_FILTER_PRODUCT_IDS);
  localStorage.removeItem(CURRENT_FILTER_SALES_UNIT_IDS);
  localStorage.removeItem(USER_LAST_ACTION);
};

export const getCompanyId = () => {
  return localStorage.getItem(COMPANY_ID);
};

export const setCompanyId = (value: string) => {
  return localStorage.setItem(COMPANY_ID, value);
};

export const getCompanyName = () => {
  return localStorage.getItem(COMPANY_NAME);
};

export const setCompanyName = (value: string) => {
  return localStorage.setItem(COMPANY_NAME, value);
};

export const saveCompanyTenantId = (tenantId: string) =>
  localStorage.setItem(COMPANY_TENANT_ID, tenantId);

export const getCompanyTenantId = () => localStorage.getItem(COMPANY_TENANT_ID);

// Tenant ID
export const getTenantId = () => localStorage.getItem(TENANT_ID);

export const saveIngredientFilters = (
  ingredientIds: number[],
  supplierIds: number[],
  dataTypeIds: number[],
  sortBy: number
) => {
  localStorage.setItem(IngredientFilterKeys.INGREDIENT_IDS, JSON.stringify(ingredientIds));
  localStorage.setItem(IngredientFilterKeys.SUPPLIER_IDS, JSON.stringify(supplierIds));
  localStorage.setItem(IngredientFilterKeys.DATA_TYPE_IDS, JSON.stringify(dataTypeIds));
  localStorage.setItem(IngredientFilterKeys.STATUS, String(sortBy));
};

export const saveFacilityFilter = (selectedFacilityTypes: string[]) =>
  localStorage.setItem(filterFacilityTypesKey, JSON.stringify(selectedFacilityTypes));

export const getFacilityFilter = (): string[] => {
  const currentFilterFacilityTypes = localStorage.getItem(filterFacilityTypesKey);
  return currentFilterFacilityTypes ? JSON.parse(currentFilterFacilityTypes) : [];
};

export const saveClientRequestFilters = (productIds: string[], status: number) => {
  localStorage.setItem(ClientRequestFilterKeys.PRODUCT_IDS, JSON.stringify(productIds));
  localStorage.setItem(ClientRequestFilterKeys.STATUS, `${status}`);
};

export const getClientRequestFilters = () => {
  const currentFilterProductIds = localStorage.getItem(ClientRequestFilterKeys.PRODUCT_IDS);
  const requestStatus = localStorage.getItem(ClientRequestFilterKeys.STATUS);
  return {
    currentFilterProductIds,
    requestStatus
  };
};

export const saveSupplierFilters = (
  isSupplierAsUser: string,
  supplierTypes: string[],
  orderBy: string
) => {
  localStorage.setItem("isSupplierAsUser", JSON.stringify(isSupplierAsUser));
  localStorage.setItem("currentFilterSupplierTypes", JSON.stringify(supplierTypes));
  localStorage.setItem(SUPPLIER_ORDER_BY, JSON.stringify(orderBy));
};

export const getSupplierFilters = () => {
  const isSupplierAsUser = localStorage.getItem("isSupplierAsUser");
  const supplierTypes = localStorage.getItem("currentFilterSupplierTypes");
  const orderBy =
    localStorage.getItem(SUPPLIER_ORDER_BY) ?? localStorage.getItem("orderBy");

  return {
    isSupplierAsUser: parseStoredJsonValue(isSupplierAsUser, "all"),
    supplierTypes: parseStoredJsonValue<string[]>(supplierTypes, []),
    orderBy: parseStoredJsonValue(orderBy, "createdAtDesc")
  };
};

export const resetSupplierFilters = () => {
  localStorage.setItem("isSupplierAsUser", JSON.stringify("all"));
  localStorage.setItem("currentFilterSupplierTypes", JSON.stringify([]));
  localStorage.setItem(SUPPLIER_ORDER_BY, JSON.stringify("createdAtDesc"));
};
